'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { LuUser } from 'react-icons/lu';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-buttons';

type HeaderProfileButtonProps = {
  className?: {
    profile?: string;
  };
  isHomepage?: boolean;
};

export const HeaderProfileButton = ({ className, isHomepage }: HeaderProfileButtonProps) => {
  const { t } = useTranslations();
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!me)
    return (
      <Button
        size={'icon'}
        aria-label={t('text190')}
        onClick={handleSignInClick}
        variant={isHomepage ? 'alternative-alt' : 'alternative-default'}
        className={cn(className?.profile)}
      >
        <LuUser size={20} aria-hidden="true" />
      </Button>
    );

  return (
    <Button
      asChild
      aria-label={t('text486')}
      size={'icon'}
      variant={isHomepage ? 'alternative-alt' : 'alternative-default'}
      className={cn(className?.profile)}
    >
      <Link prefetch={true} href={ROUTES.PROFILE()}>
        <LuUser size={20} aria-hidden="true" />
      </Link>
    </Button>
  );
};
